export default [
  {
    url: '/doctor-clinic/shop',
    name: 'Shop',
    icon: 'HomeIcon',
    slug: 'shop',
    i18n: ['AU'].includes(process.env.VUE_APP_REGION) ? 'Products' : 'Shop',
  },
  {
    url: '/doctor-clinic/orders',
    name: 'Orders',
    slug: 'orders',
    i18n: 'Orders',
    icon: 'ListIcon',
  },
  {
    url: '/doctor-clinic/settings',
    name: 'Settings',
    slug: 'settings',
    i18n: 'Settings',
    icon: 'SettingsIcon',
  },
];
